export default "__VITE_ASSET__Co$f1cEp__"